import React from 'react';
import { Check as CheckIcon } from '@livingdesign/icons';

import styles from './styles.module.css';
import { Body } from '@walmart-web/livingdesign-components';

type Step = {
  label?: string;
};

type Props = {
  steps: Step[];
  currentStep: number;
};

const getStepClasses = (currIdx: number, currStep: number) => {
  const classes = [styles.step];
  if (currIdx < currStep) classes.push(styles.active, styles.previous);
  if (currIdx === currStep) classes.push(styles.active, styles.current);
  return classes.join(' ');
};

const Stepper: React.FC<Props> = ({ steps, currentStep }) => {
  return (
    <div className={styles.stepperContainer}>
      {steps.map(({ label }, index) => (
        <div key={index} className={getStepClasses(index, currentStep)}>
          {index !== 0 && <div className={styles.connector} />}
          <Body size="medium" UNSAFE_className={styles.circle}>
            {index < currentStep ? <CheckIcon size="medium" /> : index + 1}
          </Body>
          {label && (
            <Body size="small" UNSAFE_className={styles.stepLabel}>
              {label}
            </Body>
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
